import { useState, type FormEvent } from 'react';
import type { Comment } from '@/types';

interface CommentSectionProps {
  initial: Comment[];
}

export default function CommentSection({ initial }: CommentSectionProps) {
  const [items, setItems] = useState<Comment[]>(initial);
  const [text, setText] = useState('');
  const [note, setNote] = useState('');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const value = text.trim();
    if (!value) return;
    const local: Comment = {
      id: `local-${Date.now()}`,
      user: '游客用户',
      avatarColor: 'bg-primary-500',
      content: value,
      date: '刚刚',
      likes: 0,
    };
    setItems([local, ...items]);
    setText('');
    setNote('评论已在本页面临时展示，刷新后不会保留（演示用）。');
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className="mb-5">
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          maxLength={500}
          rows={3}
          placeholder="说说你对这部剧的看法…（演示用，内容不会真正保存）"
          className="w-full resize-none rounded-lg border border-background-300 focus:border-primary-400 bg-background-50 px-4 py-3 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none transition-colors"
        />
        <div className="mt-2 flex items-center justify-between">
          <span className="text-xs text-foreground-400">{text.length}/500</span>
          <button
            type="submit"
            className="cursor-pointer whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium px-5 py-2 rounded-full transition-colors"
          >
            发表评论
          </button>
        </div>
        {note && <p className="mt-2 text-xs text-accent-700 bg-accent-100 rounded-md px-3 py-2">{note}</p>}
      </form>

      <ul className="space-y-4">
        {items.map((c) => (
          <li key={c.id} className="flex gap-3">
            <span className={`w-9 h-9 shrink-0 rounded-full ${c.avatarColor} text-white flex items-center justify-center text-sm font-medium`}>
              {c.user.slice(0, 1)}
            </span>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-foreground-900">{c.user}</span>
                <span className="text-xs text-foreground-400">{c.date}</span>
              </div>
              <p className="mt-1 text-sm text-foreground-700 leading-relaxed">{c.content}</p>
              <button className="mt-1.5 flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                <i className="ri-thumb-up-line"></i> {c.likes}
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}